import React from "react";
import classNames from "classnames";
import s from "./BreadCrumbs.scss?module";
import { useNavigate } from "react-router-dom";

export default function Breadcrumbs({ breadcrumbs }) {
  let navigate = useNavigate();

  const onItemClick = (pathname, id, isHref) => {
    if (pathname === "/" && id === 0) {
      window.location.href = "/";
      return;
    } else if (isHref) {
      window.location.href = pathname;
      return;
    }

    navigate(pathname);
  };

  return (
    <>
      <ul className={classNames("d-flex")}>
        {breadcrumbs.map((item, index) => {
          return (
            <li
              key={item.id}
              className={classNames("d-flex justify-content-center")}
              onClick={
                item.isActive
                  ? () => ({})
                  : () => onItemClick(item.pathname, item.id, item.isHref)
              }
            >
              <span
                className={classNames("d-flex justify-content-center", s.item, {
                  [s.inactive]: item.isActive,
                })}
              >
                {item.name}
              </span>
              <span className={classNames(s.inactive)}>
                {index === breadcrumbs.length - 1 ? "" : "/"}
              </span>
            </li>
          );
        })}
      </ul>
    </>
  );
}
